/*
 * @Author: bbqin
 * @Date: 2022-08-24 16:47:58
 * @LastEditTime: 2023-05-29 14:31:17
 * @LastEditors: bbqin
 * @Description: 组件属性扩展。
 * @FilePath: \Platform_Front\src\platform\FastExtend\adapters\component.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as constant from '../const';
import * as log from '../utils/log';
import { isFunction } from '../utils/type';

import { getCacheExtendJson, analysisPageEventExtend, analysisComponentEventExtend } from '../model/free';
import { compatibleCheckedMethod, compatibleBeforeAndAfter, hasExtendMethod } from '../model/single';

// 空方法
const EmptyFunction = constant.emptyFunction;

/**
 * form组件  createForm(moduleId, config = {})
 * @param {*} freeExtendCacheJson 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 */
const analysisFormConfig = function (freeExtendCacheJson, moduleId, config, output, pageScope) {

    // 如果没有moduleId，不进行操作
    if (!moduleId) {
        return config;
    }

    // 避免对象引用
    let outputConfig = { ...config };

    // 旧版本兼容
    if (!freeExtendCacheJson) {
        let hasBeforeEventExtend = hasExtendMethod(pageScope, 'onFormBeforeEvent');
        if (hasBeforeEventExtend) {
            let originEvent = config['onBeforeEvent'];
            outputConfig['onBeforeEvent'] = (...rest) => {
                let fxParams = { areaId: rest[1], itemId: rest[2], moduleId: rest[1], attrcode: rest[2], methods: rest[0], form: rest[4], item: rest[3] };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode: rest[2], fxType: 'onFormBeforeEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }

        let hasAfterEventExtend = hasExtendMethod(pageScope, 'onFormAfterEvent');
        if (hasAfterEventExtend) {
            let originEvent = config['onAfterEvent'];
            outputConfig['onAfterEvent'] = (...rest) => {
                let fxParams = { areaId: rest[1], itemId: rest[2], moduleId: rest[1], attrcode: rest[2], methods: rest[0], form: rest[6], finalValue: rest[3], oldValue: rest[4], val: rest[5] };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode: rest[2], fxType: 'onFormAfterEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }

        return outputConfig;
    }

    let { component = {} } = freeExtendCacheJson || {};

    // 组件 包含事件和属性
    let componentExtend = component[moduleId] || {};

    // 把钩子事件包装一下
    for (const key in componentExtend) {
        if (Object.hasOwnProperty.call(componentExtend, key)) {
            if (key !== 'field') {
                // 源事件
                let originEvent = config[key];
                outputConfig[key] = (...rest) => {
                    let fxParams = [...rest];
                    // 第一个参数不是是output
                    if (!rest[0] || !rest[0].meta) {
                        fxParams = [output, ...rest];
                    }
                    // 存在attrcode的钩子
                    let attrcode = '';
                    if (key === 'onBeforeEvent' || key === 'onAfterEvent') {
                        attrcode = rest[2];
                    }
                    let res = analysisComponentEventExtend.call(pageScope, freeExtendCacheJson, { moduleId, fxType: key, attrcode, fxParams }, () => {
                        if (isFunction(originEvent)) {
                            return originEvent.call(pageScope, ...rest);
                        }
                        if (key === 'onBeforeEvent') {
                            return true;
                        }
                    });
                    return res;
                };

            }
        }
    }

    // 属性
    let componentField = componentExtend['field'];

    if (!componentField) {
        return outputConfig;
    }

    // 第二步  取扩客开添加的区域属性
    componentField = (component[moduleId] || {})['field'];

    // 合并区域属性
    if (componentField) {
        // 参数可能为空
        outputConfig = { ...outputConfig, ...componentField };
    }

    return outputConfig;
};

/**
 * 编辑表格组件 editTable createEditTable(moduleId, config={}) 
 * @param {*} freeExtendCacheJson 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 * @returns 
 */
const analysisEditTableConfig = function (freeExtendCacheJson, moduleId, config, output, pageScope) {

    // 如果没有moduleId，不进行操作
    if (!moduleId) {
        return config;
    }

    // 避免对象引用
    let outputConfig = { ...config };

    // 旧版本兼容
    if (!freeExtendCacheJson) {
        let hasBeforeEventExtend = hasExtendMethod(pageScope, 'onEditTableBeforeEvent');
        if (hasBeforeEventExtend) {
            let originEvent = config['onBeforeEvent'];
            outputConfig['onBeforeEvent'] = (...rest) => {
                let attrcode = (rest[2] || {}).attrcode;
                let fxParams = {
                    moduleId: rest[1],
                    record: rest[5],
                    attrcode,
                    methods: rest[0],
                    output: rest[0],
                    column: rest[2],
                    index: rest[3],
                    val: rest[4],
                    value: rest[4],
                };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode, fxType: 'onEditTableBeforeEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }

        let hasAfterEventExtend = hasExtendMethod(pageScope, 'onEditTableAfterEvent');
        if (hasAfterEventExtend) {
            let originEvent = config['onAfterEvent'];
            outputConfig['onAfterEvent'] = (...rest) => {
                let fxParams = {
                    moduleId: rest[1],
                    record: rest[6],
                    attrcode: rest[2],
                    methods: rest[0],
                    output: rest[0],
                    val: rest[3],
                    value: rest[3],
                    changedRows: rest[4],
                    index: rest[5],
                    type: 'table',
                    actionTag: rest[8],
                };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode: rest[2], fxType: 'onEditTableAfterEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }
        return outputConfig;
    }

    let { component = {} } = freeExtendCacheJson || {};

    // 组件 包含事件和属性
    let componentExtend = component[moduleId] || {};

    // 把钩子事件包装一下
    for (const key in componentExtend) {
        if (Object.hasOwnProperty.call(componentExtend, key)) {
            if (key !== 'field') {
                // 源事件
                let originEvent = config[key];
                outputConfig[key] = (...rest) => {
                    let fxParams = [...rest];
                    // 第一个参数不是是output
                    if (!rest[0] || !rest[0].meta) {
                        fxParams = [output, ...rest];
                    }
                    // 存在attrcode的钩子
                    let attrcode = '';
                    if (key === 'onBeforeEvent' || key === 'onAfterEvent') {
                        attrcode = rest[2];
                    }
                    let res = analysisComponentEventExtend.call(pageScope, freeExtendCacheJson, { moduleId, fxType: key, attrcode, fxParams }, () => {
                        if (isFunction(originEvent)) {
                            return originEvent.call(pageScope, ...rest);
                        }
                        if (key === 'onBeforeEvent') {
                            return true;
                        }
                    });
                    return res;
                };
            }
        }
    }

    // 属性
    let componentField = componentExtend['field'];

    if (!componentField) {
        return outputConfig;
    }

    // 第二步  取扩客开添加的区域属性
    componentField = (component[moduleId] || {})['field'];

    // 合并区域属性
    if (componentField) {
        // 参数可能为空
        outputConfig = { ...outputConfig, ...componentField };
    }

    return outputConfig;
};

/**
 * 卡片表格组件 cardTable createCardTable(moduleId, config={}) 
 * @param {*} freeExtendCacheJson 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 * @returns 
 */
const analysisCardTableConfig = function (freeExtendCacheJson, moduleId, config, output, pageScope) {

    // 如果没有moduleId，不进行操作
    if (!moduleId) {
        return config;
    }

    // 避免对象引用
    let outputConfig = { ...config };

    // 旧版本兼容
    if (!freeExtendCacheJson) {
        let hasBeforeEventExtend = hasExtendMethod(pageScope, 'onCardTableBeforeEvent');
        if (hasBeforeEventExtend) {
            let originEvent = config['onBeforeEvent'];
            outputConfig['onBeforeEvent'] = (...rest) => {
                let attrcode = rest[2];
                let fxParams = {
                    moduleId: rest[1],
                    record: rest[5],
                    attrcode,
                    methods: rest[0],
                    output: rest[0],
                    index: rest[4],
                    val: rest[3],
                    value: rest[3],
                };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode, fxType: 'onCardTableBeforeEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }

        let hasAfterEventExtend = hasExtendMethod(pageScope, 'onCardTableAfterEvent');
        if (hasAfterEventExtend) {
            let originEvent = config['onAfterEvent'];
            outputConfig['onAfterEvent'] = (...rest) => {
                let fxParams = {
                    moduleId: rest[1],
                    record: rest[6],
                    attrcode: rest[2],
                    methods: rest[0],
                    output: rest[0],
                    val: rest[3],
                    value: rest[3],
                    changedRows: rest[4],
                    index: rest[5],
                    actionTag: rest[8],
                };
                let res = compatibleBeforeAndAfter(pageScope, { moduleId: rest[1], attrcode: rest[2], fxType: 'onCardTableAfterEvent', fxParams }, () => {
                    if (isFunction(originEvent)) {
                        return originEvent.call(pageScope, ...rest);
                    }
                    return true;
                });
                return res;
            };
        }
        return outputConfig;
    }

    let { component = {} } = freeExtendCacheJson || {};

    // 组件 包含事件和属性
    let componentExtend = component[moduleId] || {};

    // 把钩子事件包装一下
    for (const key in componentExtend) {
        if (Object.hasOwnProperty.call(componentExtend, key)) {
            if (key !== 'field') {
                // 源事件
                let originEvent = config[key];
                outputConfig[key] = (...rest) => {
                    let fxParams = [...rest];
                    // 第一个参数不是是output
                    if (!rest[0] || !rest[0].meta) {
                        fxParams = [output, ...rest];
                    }
                    // 存在attrcode的钩子
                    let attrcode = '';
                    if (key === 'onBeforeEvent' || key === 'onAfterEvent') {
                        attrcode = rest[2];
                    }
                    let res = analysisComponentEventExtend.call(pageScope, freeExtendCacheJson, { moduleId, fxType: key, attrcode, fxParams }, () => {
                        if (isFunction(originEvent)) {
                            return originEvent.call(pageScope, ...rest);
                        }

                        if (key === 'onBeforeEvent') {
                            return true;
                        }
                    });
                    return res;
                };
            }
        }
    }

    // 属性
    let componentField = componentExtend['field'];

    if (!componentField) {
        return outputConfig;
    }

    // 第二步  取扩客开添加的区域属性
    componentField = (component[moduleId] || {})['field'];

    // 合并区域属性
    if (componentField) {
        // 参数可能为空
        outputConfig = { ...outputConfig, ...componentField };
    }

    return outputConfig;
};

/**
 * buttonApp  createButtonApp
 * @param {*} freeExtendCacheJson 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 * @returns 
 */
const analysisButtonAppConfig = function (freeExtendCacheJson, moduleId, config, output, pageScope) {

    // 如果没有moduleId，不进行操作
    if (!moduleId) {
        return config;
    }

    // 避免对象引用
    let outputConfig = { ...config };

    // 旧版本兼容
    if (!freeExtendCacheJson) {
        let hasBeforeEventExtend = hasExtendMethod(pageScope, 'beforeBtnClick');
        let hasAfterEventExtend = hasExtendMethod(pageScope, 'afterBtnClick');

        if (hasBeforeEventExtend || hasAfterEventExtend) {
            let originEvent = config['onButtonClick'];
            outputConfig['onButtonClick'] = (...rest) => {
                let fxParams = [rest[1], { output }];

                // 点击前
                if (compatibleCheckedMethod(pageScope, 'beforeBtnClick', EmptyFunction)(...fxParams) === false) {
                    return false;
                }

                // 源事件
                let res = originEvent.call(pageScope, ...rest);

                // 点击后
                compatibleCheckedMethod(pageScope, 'afterBtnClick', EmptyFunction)(...fxParams);

                return res;
            };
        }
        return outputConfig;
    }

    let { component = {} } = freeExtendCacheJson || {};

    // 组件 包含事件和属性
    let componentExtend = component[moduleId] || {};

    // 把钩子事件包装一下
    for (const key in componentExtend) {
        if (Object.hasOwnProperty.call(componentExtend, key)) {
            if (key !== 'field') {
                // 源事件
                let originEvent = config[key];
                outputConfig[key] = (...rest) => {
                    let fxParams = [...rest];
                    // 第一个参数不是是output
                    if (!rest[0] || !rest[0].meta) {
                        fxParams = [output, ...rest];
                    }
                    let attrcode = '';
                    if (key == 'onButtonClick') {
                        attrcode = rest[1];
                    }
                    let res = analysisComponentEventExtend.call(pageScope, freeExtendCacheJson, { moduleId, fxType: key, attrcode, fxParams }, () => {
                        if (isFunction(originEvent)) {
                            return originEvent.call(pageScope, ...rest);
                        }
                    });
                    return res;
                };
            }
        }
    }

    // 属性
    let componentField = componentExtend['field'];

    if (!componentField) {
        return outputConfig;
    }

    // 第二步  取扩客开添加的区域属性
    componentField = (component[moduleId] || {})['field'];

    // 合并区域属性
    if (componentField) {
        // 参数可能为空
        outputConfig = { ...outputConfig, ...componentField };
    }

    return outputConfig;
};

/**
 * 通用
 * @param {*} freeExtendCacheJson 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 * @returns 
 */
const analysisComponentConfig = function (freeExtendCacheJson, moduleId, config, output, pageScope) {

    // 如果没有moduleId，不进行操作
    if (!moduleId) {
        return config;
    }

    // 旧版本兼容
    if (!freeExtendCacheJson) {
        return config;
    }

    // 避免对象引用
    let outputConfig = { ...config };

    let { component = {} } = freeExtendCacheJson || {};

    // 组件 包含事件和属性
    let componentExtend = component[moduleId] || {};

    // 把钩子事件包装一下
    for (const key in componentExtend) {
        if (Object.hasOwnProperty.call(componentExtend, key)) {
            if (key !== 'field') {
                // 源事件
                let originEvent = config[key];
                outputConfig[key] = (...rest) => {
                    let fxParams = [...rest];
                    // 第一个参数不是是output
                    if (!rest[0] || !rest[0].meta) {
                        fxParams = [output, ...rest];
                    }
                    let attrcode = '';
                    let res = analysisComponentEventExtend.call(pageScope, freeExtendCacheJson, { moduleId: moduleId, fxType: key, attrcode, fxParams }, () => {
                        if (isFunction(originEvent)) {
                            return originEvent.call(pageScope, ...rest);
                        }
                    });
                    return res;
                };
            }
        }
    }

    // 属性
    let componentField = componentExtend['field'];

    if (!componentField) {
        return outputConfig;
    }

    // 第二步  取扩客开添加的区域属性
    componentField = (component[moduleId] || {})['field'];

    // 合并区域属性
    if (componentField) {
        // 参数可能为空
        outputConfig = { ...outputConfig, ...componentField };
    }

    return outputConfig;
};

/**
 * 处理组件beforeTriggerCreate
 * @param {*} extendName 
 * @param {*} moduleId 
 * @param {*} componentName 
 * @param {*} originName 
 * @param {*} params 
 * @param {*} output 
 * @param {*} pageScope 
 * @returns 
 */
const analysisComponentCreate = function (extendName, componentName, originName, params = [], output, pageScope) {

    let freeExtendCacheJson = getCacheExtendJson();

    // 输出的参数
    let outputParams = params;

    switch (true) {
        // 表单
        case componentName === 'form' && originName === 'createForm':
            // 使用代码块  避免变量名冲突
            {
                let [moduleId, config = {}, ...others] = params;
                config = analysisFormConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [moduleId, config, ...others];
            }
            break;
        case componentName === 'editTable' && originName === 'createEditTable':
            {
                let [moduleId, config = {}, ...others] = params;
                config = analysisEditTableConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [moduleId, config, ...others];
            }
            break;
        case componentName === 'cardTable' && originName === 'createCardTable':
            {
                let [moduleId, config = {}, ...others] = params;
                let multiConfig = config.multiConfig;
                // 多来源多页签
                if (multiConfig) {
                    for (const tabId in multiConfig) {
                        let tabConfig = multiConfig[tabId];
                        tabConfig = analysisCardTableConfig.call(this, freeExtendCacheJson, tabId, tabConfig, output, pageScope);
                        multiConfig[tabId] = tabConfig;
                    }
                } else {
                    config = analysisCardTableConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                }
                outputParams = [moduleId, config, ...others];
            }
            break;
        case componentName === 'button' && originName === 'createButtonApp':
            {
                let [config = {}, ...others] = params;
                let moduleId = config['area'];
                config = analysisButtonAppConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [config, ...others];
            }
            break;

        // 上面是特殊的  下面的比较通用
        case componentName === 'simpleTable' && originName === 'createSimpleTable':
        case componentName === 'button' && originName === 'createButton':
        case componentName === 'cardContainer' && originName === 'createCardContainer':
        case componentName === 'dragWidthCom' && originName === 'createDragWidthCom':
        case componentName === 'treeTable' && originName === 'treeTableCol':
        case componentName === 'search' && originName === 'NCCreateSearch':
        case componentName === 'modal' && originName === 'createModal':
        case componentName === 'modal' && originName === 'CreateNCModal':
            {
                let [moduleId, config = {}, ...others] = params;
                config = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [moduleId, config, ...others];
            }
            break;
        case componentName === 'button' && originName === 'createErrorFlag':
        case componentName === 'cardPagination' && originName === 'createCardPagination':
        case componentName === 'BillHeadInfo' && originName === 'createBillHeadInfo':
        case componentName === 'socket' && originName === 'connectMesg':
            {
                let [config = {}, ...others] = params;
                // 由于一个页面只有一个  默认设置固定id
                let moduleId = originName;
                config = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [config, ...others];
            }
            break;
        case componentName === 'insertTable' && originName === 'createInsertTable':
        case componentName === 'transferTable' && originName === 'createTransferTable':
            {
                let [config = {}, ...others] = params;
                // 由于一个页面只有一个  默认设置固定id
                let moduleId = config['headTableId'] || originName;
                config = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [config, ...others];
            }
            break;
        case componentName === 'transferTable' && originName === 'createMultiTransferTable':
            {
                let [config = {}, tabConfigs = [], ...others] = params;
                // 由于一个页面只有一个  默认设置固定id
                let moduleId = config['allHeadId'] || originName;
                config = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                tabConfigs = tabConfigs.map(tabConfig => {
                    let moduleId = tabConfig['headTableId'] || originName;
                    tabConfig = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, tabConfig, output, pageScope);
                    return tabConfig;
                }, this);
                outputParams = [config, tabConfigs, ...others];
            }
            break;
        case componentName === 'syncTree' && originName === 'createSyncTree':
        case componentName === 'syncTree' && originName === 'createAsyncTree':
            {
                let [config = {}, ...others] = params;
                // 由于一个页面只有一个  默认设置固定id
                let moduleId = config['treeId'] || originName;
                config = analysisComponentConfig.call(this, freeExtendCacheJson, moduleId, config, output, pageScope);
                outputParams = [config, ...others];
            }
            break;
        default:
            break;
    }

    // 执行 页面级 beforeTriggerCreate 事件
    let pageEventResult = null;
    if (freeExtendCacheJson) {
        pageEventResult = analysisPageEventExtend(freeExtendCacheJson, extendName, pageScope, EmptyFunction, componentName, originName, params, output);
    } else {
        pageEventResult = compatibleCheckedMethod(pageScope, extendName)(componentName, originName, params, output);
    }

    return pageEventResult || outputParams;
};

/**
 * 注入修改方法参数的回调
 * @param {*} methods 
 * @param {*} param1 
 * @returns 
 */
export const methodsInterceptor = function (methods, { componentName, entries = [] } = {}) {

    !Array.isArray(entries) && (entries = [entries]);

    let that = this;

    entries.forEach(entry => {
        let { name: originName, extend: extendName = 'beforeTriggerCreate' } = entry;
        if (methods[originName]) {
            let oldMethods = methods[originName];
            methods[originName] = (...params) => {
                try {
                    let nextPrams = analysisComponentCreate.call(this, extendName, componentName, originName, params, that.output, that);
                    params = nextPrams || params;

                    // log.blue(`${componentName}  调用方法 ${originName} `, extendName, componentName, originName, params);
                } catch (error) {
                    log.error(false, `${componentName}  调用方法 ${originName} , 执行报错`, error);
                }

                return oldMethods.call(that, ...params);
            };
        }
    });

    return methods;
};
